import React, { Suspense, lazy } from 'react';

import { useThemeProps } from '@mui/material/styles';

import { useUtils } from '@ezbobdev/ui-commons';
import { useTranslation } from '@ezbobdev/ui-framework';

import { styled } from '../../Utils/style';
import MaterialTypography from '../MaterialTypography/MaterialTypography';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Spinner = React.forwardRef(function Stat(inProps, ref) {
  const {
    variant = 'SpinnerSingle',
    primaryColor = 'primary.light',
    secondaryColor = 'primary.dark',
    children,
  } = useThemeProps({ props: inProps, name: 'Spinner' });

  const { t } = useTranslation();

  const { getConfig } = useUtils(inProps, Spinner.displayName);
  const shouldAnnounce = getConfig('shouldAnnounce', true);

  const SpinerLazy = lazy(() => import(`./${variant}.styled`));

  return (
    <Suspense>
      <Wrapper role={shouldAnnounce ? 'alert' : undefined}>
        <SpinerLazy $primaryColor={primaryColor} $secondaryColor={secondaryColor} sx={{ mb: 4 }} ref={ref} />
        {children ?? <MaterialTypography srOnly={true}>{t('globals.loading')}</MaterialTypography>}
      </Wrapper>
    </Suspense>
  );
});

Spinner.displayName = `Spinner`;

export default Spinner;
